import { Box, Button, CircularProgress } from '@mui/material';
import React from 'react';
import { SaveButtonsProps } from './SaveButtons.types';

const SaveButtons = ({ handleSubmit, isUpdating, handleCancel }: SaveButtonsProps) => {
  const scrollToTop = (): void => {
    if (typeof window.scrollTo !== 'function') {
      return;
    }

    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    } catch {
      // JSDOM may expose scrollTo without implementing it.
    }
  };

  const handleContinueEditingClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    void (async () => {
      try {
        await handleSubmit(e, false);
      } finally {
        scrollToTop();
      }
    })().catch(() => {
      // Submit handlers already surface validation and API errors in local UI state.
    });
  };

  return (
    <Box display="flex" gap={2} sx={{ mt: 2 }}>
      {/* Przycisk Anuluj (opcjonalny) */}
      {handleCancel && (
        <Button
          type="button"
          variant="outlined"
          color="inherit"
          onClick={handleCancel}
          disabled={isUpdating}
        >
          Anuluj
        </Button>
      )}

      {/* Zapisz zmiany + PRZEKIEROWANIE */}
      <Button
        type="button"
        variant="contained"
        color="primary"
        onClick={(e) => handleSubmit(e, true)}
        disabled={isUpdating}
        startIcon={isUpdating ? <CircularProgress size={20} /> : undefined}
      >
        {isUpdating ? 'Zapisywanie...' : 'Zapisz zmiany'}
      </Button>

      <Button
        type="button"
        variant="outlined"
        color="primary"
        onClick={handleContinueEditingClick}
        disabled={isUpdating}
        startIcon={isUpdating ? <CircularProgress size={20} /> : undefined}
      >
        {isUpdating ? 'Zapisywanie...' : 'Zapisz i kontynuuj edycję'}
      </Button>
    </Box>
  );
};

export default SaveButtons;
